const settings = {
  baseApiUrl: "https://staging-api.vaix.ai",
  operator: "betplay_casino",
  apiAuthToken:
    "ae60fa09afa41acab7e1c923cb85407ea461149673f430c396b74abaf23eb9a7",
  components: {
    sliderItem: {
      magnifyOnHover: true,
      showPlayBtnOnHover: true,
      tags: [],
    },
    slider: {
      moreBtnHover: true,
    },
  },
};

export default settings;
